<template>
  <div class="OrderEdit">
    <div class="grid">
      <section id="leftPane">

        <h1>{{dynamicTitle(data.mode)}}</h1>
        <p class="warningMessage" v-if="isWarning">!未入力の項目があります!</p>

        <div>
          <div class="clearfix">
            <h2 class="inputTitle" id="addressInputTitle">{{dynamicTitle('destinationAddress')}}</h2>
            <button id="selectByPlacesButton" @click="openModal('placeSelect')">ビル名から入力</button>

          </div>

          <input class="addressInput" :class="{warned: (isWarning && !(data.address && data.latitude > 0 && data.longitude > 0))}" type="text" placeholder="住所"  v-model="data.searchAddressInput">

          <div id="searchLocationButtonArea">
            <button id="searchLocationButton" class="button" @click="searchLocation">この住所を検索</button>
          </div>
        </div>


        <p class="destinationAddress" v-if="data.address">{{data.address}}</p>
        <p class="destinationPosition" v-if="data.latitude > 0">{{data.latitude}}, {{data.longitude}}</p>


        <div>
          <h2 class="inputTitle" >{{dynamicTitle('destinationName')}}</h2>
          <input type="text" :placeholder="dynamicTitle('destinationNameHint')" v-model="data.destinationName">
        </div>

        <div>
          <h2 class="inputTitle" >{{dynamicTitle('clientName')}}</h2>
          <input type="text" :placeholder="dynamicTitle('clientNameHint')" v-model="data.clientName">
        </div>

        <div>
          <h2 class="inputTitle" >{{dynamicTitle('deliveryContentName')}}</h2>
          <input type="text" :placeholder="dynamicTitle('deliveryContentNameHint')" v-model="data.name">
        </div>

        <div>
          <h2 class="inputTitle" >ドライバー</h2>
          <select class="driverSelect" :class="{warned: (isWarning && !(data.selected_driver_id))}" v-model="data.selected_driver_id">
            <option value="" disabled>ドライバーを選択してください</option>
            <option v-for="(driver,index) in data.drivers" :value="driver.id" :key="index">
              {{ driver.name }}
            </option>
          </select>
        </div>

        <div id="createOrderButtonArea">
          <button class="button" :class="{disabled: isButtonDisabled}" @click="checkForm" v-if="data.mode == 'createOrder'">作成する</button>
          <button class="button" :class="{disabled: isButtonDisabled}" @click="checkForm" v-if="data.mode == 'updateOrder'">編集を完了する</button>
          <button class="button deleteButton" @click="openModal('deleteOrder')" v-if="data.mode == 'updateOrder'">削除する</button> 
        </div>
      </section>


      <gmap-map
        id="map"
        ref="map"
        :center="{lat: center.latitude, lng: center.longitude}"
        :zoom="17"
      >
        <gmap-marker
          :key="index"
          v-for="(m, index) in markers"
          :position="{lat: m.latitude, lng: m.longitude}"
        ></gmap-marker>
      </gmap-map>
    </div>

    <!-- PlaceSelector Modal -->
    <div class="modalBackground" v-if="modal.placeSelect" @click.self="closeModal('placeSelect')">
      <div class="modalDialog">

        <h2>ビル名から入力</h2>


        <label>
          <gmap-autocomplete
            class="placeInput"
            @place_changed="setPlace">
          </gmap-autocomplete>
        </label>


        <div class="clearfix">
          <button id="selectPlaceButton" class="button" :class="{disabled: !currentPlace}"  @click="addPlace">この場所を選択</button>
        </div>

      </div>
    </div>

    <!-- DeleteOrder Modal -->
    <div class="modalBackground" v-if="modal.deleteOrder" @click.self="closeModal('deleteOrder')">
      <div class="modalDialog deleteOrderModal">
        <h2>この注文を削除してよろしいですか？</h2>

        <div id="deleteOrderModalButtonGroup" class="clearfix">
          <button class="button" @click="closeModal('deleteOrder')">注文を保存</button>
          <button class="button deleteButton" @click="$parent.deleteOrder">削除する</button>
        </div>

      </div>
    </div>

    <div class="loadingBackground" v-if="data.isLoading">
      <div class="loadingDialog">
        <half-circle-spinner
          :animation-duration="1000"
          :size="60"
          :color="'#ffffff'"
        />
      </div>
    </div>

  </div>


</template>


<script>
  import {db, fb} from '../firebase'
  import * as VueGoogleMaps from "vue2-google-maps";
  import PlacePicker from "../components/PlacePicker";
  import {HalfCircleSpinner} from 'epic-spinners'


  const words = {
    'dayservice' : {
      'createOrder' : '送迎先の新規登録',
      'updateOrder' : '送迎先の編集',
      'destinationAddress' : '送迎先住所',
      'destinationName' : '送迎先お客様氏名',
      'destinationNameHint' : '(例)郁出かよ',
      'clientName' : 'ご契約者様氏名',
      'clientNameHint' : '(例)郁出かよ',
      'deliveryContentName' : 'ご利用者様氏名',
      'deliveryContentNameHint' : '(例)郁出一郎'
    },
    'bike' : {
      'createOrder' : '注文の新規登録',
      'updateOrder' : '注文の編集',
      'destinationAddress' : '配達先住所',
      'destinationName' : '配達先お客様氏名',
      'destinationNameHint' : '配達先お客様氏名（省略可）',
      'clientName' : '依頼主',
      'clientNameHint' : '依頼主（省略可）',
      'deliveryContentName' : 'お届け物',
      'deliveryContentNameHint' : 'お届け物（省略可）'
    },
    'default' : {
      'createOrder' : '送迎又は注文の新規登録',
      'updateOrder' : '送迎又は注文の編集',
      'destinationAddress' : '送迎先・配達先住所',
      'destinationName' : '送迎先・配達先お客様氏名',
      'destinationNameHint' : '送迎先・配達先お客様氏名（省略可）',
      'clientName' : '依頼主',
      'clientNameHint' : '依頼主（省略可）',
      'deliveryContentName' : '送迎のご利用者様、又はお届けする物',
      'deliveryContentNameHint' : ''
    }
  }

  export default {
    name: 'OrderEdit',
    components: {PlacePicker, HalfCircleSpinner},
    props: {
      data: {
        mode: '', 

        /* 注文の情報 */
        name: '',
        address: null,
        latitude: 0,
        longitude: 0,
        destinationName: '',
        clientName: '',
        selected_driver_id: null,
        
        /* Input Form */ 
        searchAddressInput: '',

        isLoading: false,
        company: null
      },
    },
    data() {
      return {
        /* 住所検索 */
        center: { latitude: 45.508, longitude: -73.587 },
        markers: [],
        places: [],
        currentPlace: null,
        geocoder: {},

        /* ドライバーリスト(Firestoreから取得) */
        drivers: [],

        /* 入力にエラーがあるかどうかのフラグ */
        isWarning: false,

        /* モーダルが表示されているかどうかのフラグ */
        modal: {
          placeSelect: false, /* 場所選択モーダル */
          deleteOrder: false, /* 削除確認モーダル */
        },
      }
    },
    computed: {
      companyId() {
        let coId = this.$store.getters.companyId
        if(coId){
          return coId
        }

        //localStorageに存在したらそれをVuexのstoreに書き込んでリターンする。
        if (localStorage.companyId) {
          this.$store.commit('setCompanyId', localStorage.companyId)
          return localStorage.companyId
        }
      },

      isButtonDisabled() {
      //TODO: this.nameもチェックするようにする。this.destinationNameもチェックするようにするか検討する。
        if(this.data.address && this.data.latitude && this.data.longitude && this.data.clientName && this.data.selected_driver_id){
          return false
        }
        return true
      }
    },

    methods: {

      getDrivers () {
        this.$bind('data.drivers', db.collection('companies').doc(this.companyId).collection('drivers')).then(drivers => {
          //this.$unbind('drivers')
        })
      },

      async checkForm() {
        if(this.isButtonDisabled){
          console.log("button is disabled")
          this.isWarning = true
          return
        }

        this.isWarning = false

        let router = this.$router
        return this.$parent.submitOrder() 
      },

      // receives a place object via the autocomplete component
      setPlace(place) {
        this.currentPlace = place;
      },

      addPlace() {
        if (this.currentPlace) {
          this.onFindPlace(this.currentPlace)

          //モーダルを閉じる
          this.closeModal('placeSelect')

          //住所を住所検索インプットに登録
          this.data.searchAddressInput = this.currentPlace.formatted_address
        }
      },

      geolocate: function() {
        navigator.geolocation.getCurrentPosition(position => {
          this.center = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          };
        });
      },

      searchLocation: function() {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({'address': this.data.searchAddressInput}, (results, status) => {
          if (status === 'OK') {
            let place = results[0]
            this.onFindPlace(place)
          }
        });
      },

      onFindPlace(place) {
        console.log(place.formatted_address)


        this.data.address = place.formatted_address
        this.data.latitude = place.geometry.location.lat()
        this.data.longitude = place.geometry.location.lng()


        if (this.data.latitude && this.data.longitude) {
          let marker = {
            latitude: this.data.latitude,
            longitude: this.data.longitude
          }
          this.markers.push(marker);
          this.places.push(place);
          this.center = marker;
        }

      },


      openModal(modalName) {
        this.modal[modalName] = true
      },
      closeModal(modalName) {
        this.modal[modalName] = false
      },

      getCompany () {
        let self = this
        this.$bind('data.company', db.collection('companies').doc(this.companyId)).then(company => {
          // this.$unbind('data.company')
        })
      },


      /* ダイナミックタイトル */
      dynamicTitle(key){
        if(this.data.company){
          let type = this.data.company.type
          let wordSet = words[type]
          if(!wordSet){
            wordSet = words['default']
          }
          return wordSet[key]
        }
        return words['default'][key]
      }

    },

    /*
    firestore: {
      drivers: db.collection('companies').doc(this.companyId).collection('drivers')
    },
    */



    mounted() {

      if(!this.companyId){
        this.$router.push('/signin')
      }else{
        this.getDrivers()
        this.geolocate()
        this.getCompany()
        if(this.data.mode == 'updateOrder'){
          const self = this
          // By default, searchLocation() is only called by the button searchLocationButton (クリックするのはすぐではない) so it works fine
          // So when I tried to call searchLocation() here on mounted(), Google maps aren't completely loaded yet. “google is not defined” のエラーが出る
          // So I used setTimeout to buy some time for it load.
          setTimeout(function () {self.searchLocation()}, 1000);
        }
      }


      /* マップ初期化処理 */
      /*
      this.$refs.map.$mapPromise.then(() => {
        var geocoder = new google.maps.Geocoder();

        var address = "Dublin";

        geocoder.geocode( { 'address': address}, function(results, status) {

          if (status == google.maps.GeocoderStatus.OK) {
            var latitude = results[0].geometry.location.lat();
            var longitude = results[0].geometry.location.lng();

            console.log(latitude)


          }

        });
      })
      */


    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>




  /* CONTACT グリッドレイアウト */
  .grid {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr minmax(180px, 1fr);
    height:100vh;
  }


  #leftPane {
    text-align: left;
    margin-left: 15%;
    margin-right: 10%;
  }

  #leftPane h1{
    color: #5C5C5C;
    font-size: 33px;
    font-weight: normal;
    margin-top: 40px;
  }

  .clearfix:after {
    content: "";
    display: block;
    clear: both;

  }

  #addressInputTitle{
    float: left;
  }


  #selectByPlacesButton{
    float: right;

    margin-top: 25px;

    color: #9EC002;
    font-size: 16px;
    font-weight: normal;

    background: none;
    border-style: none;
    outline: none;


  }


  input {
    width: 100%;
    height: 36px;
    margin-top: 0;
    padding: 10px;
    border-style: solid;
    border-width: 2px;
    border-color: #D2D2D2;
    box-shadow: 0 0 0 #D2D2D2;
  }

  input:focus {
    outline: none !important;
    border:2px solid #D2FF00;
    box-shadow: 0 0 0 #D2FF00;
  }

  #searchLocationButtonArea {
    text-align: right;

  }

  .destinationAddress {
    color: #5C5C5C;
    font-weight: lighter;
    font-size: 14px;
    margin: 20px 0 0 0;
  }

  .destinationPosition{
    color: #5C5C5C;
    font-weight: lighter;
    font-size: 14px;
    margin: 0 0 20px 0;
  }


  #createOrderButtonArea {
    text-align: center;
    margin-top: 11px;
  }

  .inputTitle {
    color: #5C5C5C;
    font-size: 20px;
    font-weight: lighter;
    margin-top: 11px;

  }

  button.disabled {
    background-color: #D2D2D2;
  }


  button.disabled:hover {
    border-style: solid;
    border-width: 2px;
    border-color: #D2D2D2;
  }

  /* delete order button */
  .deleteButton {
    background-color: #FF6868;
    border: solid 2px transparent;
    color: #FFFFFF;
  }

  .deleteButton:hover {
    background-color: #FF9595;
  }

  .deleteButton:active {
    border: solid 2px #FF5151;
    border-width: 2px;
    background-color: #FF6868;
  }

  /* Loading Indicator */
  .modalBackground{
    position:fixed;
    padding:0;
    margin:0;

    top:0;
    left:0;

    width: 100%;
    height: 100%;
    background:rgba(0,0,0,0.5);
  }

  .modalDialog {
    /* https://stackoverflow.com/a/14816807/1709287 */
    width: 420px;
    height: 300px;


    position:absolute; /*it can be fixed too*/
    left:0; right:0;
    top:0; bottom:0;

    margin:auto;

    /*this to solve "the content will not be cut when the window is smaller than the content": */
    max-width:100%;
    max-height:100%;
    overflow:auto;

    background-color: white;
    border-radius: 4px;

  }

  .modalDialog h2{
    color: #5C5C5C;
    font-size: 25px;
    font-weight: normal;
    margin: 30px 0 20px 20px;
  }

  /* delete order modal */
  .deleteOrderModal {
    width: 420px;
    height: 220px;
    border-radius: 15px;
    border: 1px #707070 solid;
    font-weight: normal;
  }

  .deleteOrderModal h2{
    font-size: 18px;
    font-weight: bold;
    margin: 50px 0 20px 20px;
    text-align: center;
  }

  #deleteOrderModalButtonGroup{
    display:flex;
    align-items: center;
    justify-content: center;
  }

  #deleteOrderModalButtonGroup button{
    text-align: center;
    margin: 5px 12px;
    padding: 7px 15px;
  }
  /* end of delete order */

  .placeInput {
    width: 360px;
    margin: 0 0 0 20px;
  }


  #selectPlaceButton{
    float: right;
    margin-top: 40px;
    margin-right: 20px;

  }


  /* 未入力の項目の警告用スタイル */
  .warned {
    background-color: #F3C99F;
  }

  .warningMessage {
    color: #FF6B49;
    font-size: 18px;
    margin-top: 0;
    margin-bottom: 0;
  }

  #map{
    margin-top: 0;
    width: 100%;
    height: 100%;
  }


  /* モバイル対応 */
  @media(max-width: 400px){
    .grid {
      grid-gap: 0;
      grid-template-columns: 1fr;
    }

    #map{
      margin-top: 0;
      width: 100%;
      height: 300px;
    }


    #leftPane {
      text-align: center;
      width: 100%;
      margin-left: 0;
      margin-right: 0;
      margin-bottom: 0;
      padding: 0;
    }

    #leftPane h1{
      color: #5C5C5C;
      font-size: 21px;
      font-weight: bold;
      margin-top: 12px;
    }

    #addressInputTitle{
      float: left;
    }

    #selectByPlacesButton{
      float: right;
      margin-top: 25px;
      margin-right: 25px;
      color: #9EC002;
      font-size: 15px;
      font-weight: normal;
      background: none;
      border-style: none;
      outline: none;
    }

    input {
      width: 84%;
      height: 27px;
      margin: 0 auto 0 auto;
      padding: 10px;
      border-style: solid;
      border-width: 2px;
      border-color: #D2D2D2;
      box-shadow: 0 0 0 #D2D2D2;
    }

    input:focus {
      outline: none !important;
      border:2px solid #D2FF00;
      box-shadow: 0 0 0 #D2FF00;
    }

    #searchLocationButtonArea {
      text-align: center;

    }

    #searchLocationButton{
      font-weight: bold;
      font-size: 13px;
      padding: 7px 10px 7px 10px;
    }

    .destinationAddress {
      font-weight: lighter;
      font-size: 14px;
      margin: 4px 0 0 0;
    }

    .destinationPosition{
      font-weight: lighter;
      font-size: 14px;
      margin: 0 0 0 0;
    }


    #createOrderButtonArea button {
      text-align: center;
      margin-top: 11px;
      margin-bottom: 25px;
      padding: 7px 10px 7px 10px;
      font-weight: bold;
      font-size: 15px;
    }

    .inputTitle {
      color: #5C5C5C;
      font-size: 15px;
      font-weight: lighter;
      margin-top: 7px;
      margin-left: 7%;
      margin-bottom: 0;
      text-align: left;
    }

    /* Loading Indicator */
    .modalBackground{
      position:fixed;
      padding:0;
      margin:0;

      top:0;
      left:0;

      width: 100%;
      height: 100%;
      background:rgba(0,0,0,0.5);
    }

    .modalDialog {
      /* https://stackoverflow.com/a/14816807/1709287 */
      width: 90%;
      height: 180px;
      position:absolute; /*it can be fixed too*/
      left:0; right:0;
      top:0; bottom:0;

      margin:auto;
      /*this to solve "the content will not be cut when the window is smaller than the content": */
      max-width:100%;
      max-height:100%;
      overflow:auto;
      background-color: white;
      border-radius: 4px;
      text-align: center;
    }

    .modalDialog h2{
      color: #5C5C5C;
      font-size: 14px;
      font-weight: normal;
      margin: 10px 10px 0 10px;
    }

    .placeInput {
      width: 80%;
      height: 27px;
      margin: 0 auto 0 auto;
      font-size: 12px;
    }


    #selectPlaceButton{
      float: right;
      margin: 6px 15px 0 auto;
      padding: 7px 10px 7px 10px;
      font-weight: bold;
      font-size: 15px;
    }

    /* delete order modal モバイル対応 */
    .deleteOrderModal h2{
      font-weight: bold;
      margin: 20px 0 20px 20px;
      text-align: center;
    }

    #deleteOrderModalButtonGroup button{
      margin: 2px;
      padding: 5px 10px 5px 10px;
      font-weight: bold;
      font-size: 13px;
    }

    .driverSelect {
      margin: 0 auto 0 auto;
      padding: 0 0 0 0;
    }


    /* 未入力の項目の警告用スタイル */

    .warningMessage {
      font-size: 12px;
      margin: 0 auto 0 auto;
    }


    
  }



</style>



// WEBPACK FOOTER //
// src/components/OrderEdit.vue